import {
  INTEGER,
  TEXT,
  chapterId,
  chapter_chapterId,
  id,
  label,
  note,
  position,
  timestamp,
  userId,
  verseRange,
} from '../constants/stringsAndFields';
import {isNotEmpty} from '../utils/arrays';
import {CHAPTER_TABLE} from './chapter';
import {
  checkTableExists,
  deleteData,
  executeTransaction,
  insertData,
  selectData,
  selectDataMultiWhere,
  updateData,
} from './common';
import {getActiveUserId} from './currentUser';
import {APP_USER_TABLE} from './user';
import {LOCAL_DEFAULT_USER_ID} from './userConstants';
import {runSqlCmd, exportDatabase} from './sqlOperations';

export const NOTE_TABLE = 'Note';
const keys = [
  id,
  userId,
  chapterId,
  chapter_chapterId,
  note,
  label,
  position,
  timestamp,
  verseRange,
];

const defaultUserIdSql = `'${LOCAL_DEFAULT_USER_ID}'`;

// TODO: add index which is used for query
export const createNoteTable = async tx => {
  await runSqlCmd(tx, `DROP TABLE IF EXISTS ${NOTE_TABLE};`);
  await runSqlCmd(
    tx,
    `CREATE TABLE IF NOT EXISTS ${NOTE_TABLE}(
      ${id} ${TEXT} PRIMARY KEY NOT NULL,
      ${userId} ${TEXT} NOT NULL DEFAULT ${defaultUserIdSql},
      ${chapterId} ${TEXT},
      ${chapter_chapterId} ${TEXT},
      ${note} ${TEXT},
      ${label} ${TEXT},
      ${position} ${INTEGER},
      ${timestamp} ${INTEGER},
      ${verseRange} ${TEXT},
      FOREIGN KEY(${userId}) REFERENCES ${APP_USER_TABLE}(${userId}) ON DELETE CASCADE,
      FOREIGN KEY(${chapter_chapterId}) REFERENCES ${CHAPTER_TABLE}(${chapterId}) ON UPDATE NO ACTION ON DELETE NO ACTION);`,
  );
};

export const reCreateNoteTableAndData = async (tx, cmds) => {
  await createNoteTable(tx);
  await executeTransaction(tx, cmds);
};

export const insertNote = async (tx, noteRecord) => {
  const row = {
    ...noteRecord,
    [userId]: noteRecord[userId] ?? getActiveUserId(),
  };
  await insertData(tx, NOTE_TABLE, keys, row);
  await exportDatabase(tx);
};

export const deleteAllNotes = async tx => {
  await runSqlCmd(
    tx,
    `DELETE FROM ${NOTE_TABLE} WHERE ${userId} = '${getActiveUserId()}';`,
  );
  await exportDatabase(tx);
};

export const deleteNote = async (tx, noteRecord) => {
  await deleteData(tx, NOTE_TABLE, noteRecord[id]);
  await exportDatabase(tx);
};

export const updateNote = async (tx, noteRecord) => {
  const row = {
    ...noteRecord,
    [userId]: noteRecord[userId] ?? getActiveUserId(),
  };
  await updateData(tx, NOTE_TABLE, row, id);
  await exportDatabase(tx);
};

export const getNotes = async tx => {
  const notes = await selectData(
    tx,
    NOTE_TABLE,
    keys,
    userId,
    getActiveUserId(),
  );
  return isNotEmpty(notes) ? notes : [];
};

export const getNote = async (tx, dataId) => {
  const notes = await selectDataMultiWhere(
    tx,
    NOTE_TABLE,
    keys,
    [id, userId],
    [dataId, getActiveUserId()],
    [],
    false,
  );
  return isNotEmpty(notes) ? notes[0] : null;
};

export const checkNoteTable = async tx => {
  return await checkTableExists(tx, NOTE_TABLE);
};
